async function hasNoAgreement(entityType = "events", entityID) {
    try {
        const response = await fetch(`/api/${entityType}/${entityID}/agreement`);

        if (response.status !== 200) return false;

        const { payload } = await response.json();

        return payload;
    } catch (error) {
        return true;
    }
}

export default hasNoAgreement;
